import { useQuery } from "@tanstack/react-query";
import { decryptResponse } from "../Components/RateCard/utils";
import { Urls } from "../Urls";
import axios from "../Axios";

const fetchAuctions = async ({ queryKey }) => {
  const [, bucket, filters] = queryKey;

  const payload = {
    auction_status: bucket,
    ...(filters || {}),
  };

  const response = await axios.post(
    `${Urls.auction}?bucket=${bucket}`,
    payload
  );
  const decrypted = decryptResponse(response?.data);

  if (!decrypted?.auctions) throw new Error("No auctions found");

  return {
    auctions: decrypted.auctions,
  };
};

/**
 * Hook to fetch auctions via TanStack Query
 * @param {string} auctionBucket - 'active', 'inactive', 'closed', 'paused'
 */
export const useAuctionList = (auctionBucket, filters = {}) => {
  const shouldPoll = auctionBucket === "active";

  return useQuery({
    queryKey: ["auctions", auctionBucket, filters],
    queryFn: fetchAuctions,
    enabled: !!auctionBucket,
    staleTime: 2 * 1000, // cache freshness
    refetchOnWindowFocus: shouldPoll,
    // refetchInterval: shouldPoll ? 45 * 1000 : false, // poll every 45s for active only
  });
};
